(() => {
  "use strict";

  const SECTION = ".shopify-section--lgk-home-collections-hub";
  const TRACK = ".lgk-mesh-bubble-track--hub-grid";
  const CARD = ".lgk-mesh-bubble--hub-card";

  const isTrackVisible = (track) => {
    const details = track.closest("details");
    if (details && !details.open) return false;
    return track.getClientRects().length > 0;
  };

  const equalizeTrack = (track) => {
    const cards = track.querySelectorAll(CARD);
    if (!cards.length) return;

    cards.forEach((card) => {
      card.style.removeProperty("min-height");
      card.style.removeProperty("height");
      card.classList.remove("is-height-equalized");
    });

    let maxH = 0;
    cards.forEach((card) => {
      maxH = Math.max(maxH, card.getBoundingClientRect().height);
    });

    if (maxH <= 0) return;

    const px = `${Math.ceil(maxH)}px`;
    cards.forEach((card) => {
      card.style.minHeight = px;
      card.style.height = px;
      card.classList.add("is-height-equalized");
    });

    track.classList.add("lgk-mesh-bubble-track--equalized");
  };

  const equalizeSection = (section) => {
    section.querySelectorAll(TRACK).forEach((track) => {
      if (!isTrackVisible(track)) return;
      equalizeTrack(track);
    });
  };

  let resizeTimer;
  const onResize = () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      document.querySelectorAll(SECTION).forEach(equalizeSection);
    }, 150);
  };

  const bindSection = (section) => {
    equalizeSection(section);

    section.querySelectorAll("details.lgk-mesh-accordion").forEach((details) => {
      details.addEventListener(
        "toggle",
        () => {
          if (!details.open) return;
          requestAnimationFrame(() => {
            details.querySelectorAll(TRACK).forEach(equalizeTrack);
          });
        },
        { passive: true }
      );
    });
  };

  const init = () => {
    document.querySelectorAll(SECTION).forEach(bindSection);
    window.addEventListener("resize", onResize, { passive: true });
    window.addEventListener(
      "load",
      () => {
        document.querySelectorAll(SECTION).forEach(equalizeSection);
      },
      { passive: true }
    );
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { passive: true });
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", (event) => {
    const section = event.target?.closest?.(SECTION) || event.target;
    if (section?.matches?.(SECTION)) bindSection(section);
  });
})();
